import React, { useEffect, useState, useRef } from 'react';

import Icon from '@components/custom/Icon';

const ScrollList = ({ items, selectedItem, onClick }) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = 65;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateScrollButtons();
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, [items]);

  return (
    <div className={ `currencies-wrapper position-relative ${items.length > 4 ? `with-scroll items-${items.length}` : '' }` }>
      {items.length > 4 && (
        <div className={ `arrow prev ${!canScrollLeft ? 'disabled' : ''}` } onClick={ () => scroll("left") }>
          <Icon name='double_arrow' size={ 18 } color='#2d2d2d' style={ { rotate: '180deg' } } />
        </div>
      )}
      <ul className="d-flex currencies" ref={ scrollRef }>
        
        { items.map((item, index) => (
          <li
            key={ index }
            className={ `item ${ item.value === selectedItem ? 'active' : '' }` }
            onClick={ () => onClick(item.value) }
          >
            { item.label }
          </li>
        )) }
       
      </ul>
      {items.length > 4 && (
        <div className={ `arrow next ${!canScrollRight ? 'disabled' : ''}` }  onClick={ () => scroll("right") }>
          <Icon name='double_arrow' size={ 18 } color='#2d2d2d' />
        </div>
      )}
    </div>
  );
};

export default ScrollList;